import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Collapsible from "react-collapsible";

const reorder = (list, startindex, endindex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startindex, 1)
    result.splice(endindex, 0, removed)
    return result;
};

export default class AudioPlayerTower extends React.Component {
    state = {
        index: 1,
        currentTime: '0:00',
        musicList: [
            { audio: 'https://www.bensound.com/bensound-music/bensound-buddy.mp3', id: "0", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIADYASAMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAYDBQcCAf/EADUQAAEEAQEEBwUIAwAAAAAAAAEAAgMEEQUSITFRBhMUFUFUkiIjM2FxBzJTgYKRocFCUmL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOL93XfLSelfe7bvlpPSregQVMaNqR4UZz+godH1IcaU4/QrrJcbXiL3k48APEqRC2W0K0Qi66za+FCCQ0Dm443j+EHPzp1wHBrvB5L13RqHlJf2XSdU6IX4KgZHNTY4tw5scOM896rdJ8um3OxTyNkiLtkEH7rvogrfdGo+Tl9K8d23fLSeldBwtceJQU7u675aT0r6reiAiIOKCd0godlpUBHA54tsZILTne7a7cS36+G/l+1m6ANaLF63ZiaLIeIcneQAN+Pr/SjdFL0L2yaPqEbZatk+y1/AOWo1YydF+lHZn2nGlYYGvdnLmtO7JzxI5+IQWnpFrrbNa3FobmWbcY9rY9rYHicfJc91bSpuxW9QmNoFkjQx87NkyeBOFf8AR6Pdkj5orsVrMbWV4WRhjeeXHxJ8Sqvqti7NTt0r5if1shEXU/Didv8AYDjjaIx4ZwiIOi2+1VR1jsyM3OPPkV4PE/VaTSb4ozudI0ljhg44hbrOd/NFEREBBxWPtEP40frCCeHI99H6wg33R6MO13T2PGczjdzxv/pYPtbDm6zC7/FzOPzCm9GJqh6UU3SWa7YoI5ZS90rQA7AaBx/6Kj/afap2LleaGevYEbgS1sgcHDkcIK/ous6lpzSwV5Zomu2NktOWHl/I3fMKTqGvPnaWUtLdDbLMOleC9zGcMMB3NGeS0bNVDZorDoWGaNxJcJNzsgNOQc+DQOP5L4L9cR7HZx8PqydtnDa2uGxjj8kENzHBm0WkNPA43Kzt+6Poqy6ZnVbDcAcTl2clWJs8OyPfR8P9wgyosfaIfxo/WEQUlERAREQEREBERAREQf/Z", name: "Rolling in the Deep", author: "Adele", duration: "3:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "1", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAEgASAMBIgACEQEDEQH/xAAbAAABBAMAAAAAAAAAAAAAAAAAAQIEBQMGB//EADcQAAIBAwIEAwQIBgMAAAAAAAECAwAEEQUSEyExUQYiQRQyYZFCcYGhscHR8DRSZKLh8QcVM//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A5NRmkpKlR2TWyeHdkDqSM58xJPX/AB+pPatbQZYVe24ePhWowskpDSH+Udv32oN6lu8aZw7YhGk53Fyc4jX+VR6sfn+Wn6vql0q+z2ErR26eXyooyf1rLe6g2o3kOmwSbYUOCR/cx7n/AFW5eBdFtbxpNRkhHslsxjt4zzJYdXY+p9PnQcuutLv4FWS6gkTeNwL9cVBIKnFdN/5NuFYjaMc+VcyY5JoHq6CF0MKs5ORJuOV+zpRWOigWiirPT7GCK1XU9WV/Y9xWCBW2veOOoB+ig+k/2Dn0B+gabcXTm6EaraxNh7iZxHGG67dzEAn4Dn8Ktdc0WfSbgrqdzwbiRdzJGM7R23fZjl2qLY3slxM+t6qENhpwCwWqDZEz+8kEa+i8tzHrtBJJJBOw+PtSjt9Tiv7hUnv2gVrVJBuSFT5uM4PJmyTtU5AxuPoCGpaGOHqhQHIKsoP5/IV1JNQl8J+C7ZV9mV+FljMWOZHJYgAD49652tl/0xa9vXbjRFY5E/qH8zJ0+hGct2ZgvxroHiWaxurKP2qNZYNvQgHBxyPOg5prfiG51j+JjRSD1TNU5yOtT5bWe/1SSOzg4ryP5Vhj2j5dB+FZvEekzaPc21tc/wDq1sruOxJPL7qCpooooFq7sdGtdSj4y65DBbW8am5N1DLut1J5hQqlW8xbaoYFuw54qLeNZZ0jkmWFCfNK4JCD1OBzP1ep5VPklk1Oaz0fS0MVs06pbxyEZklcheJIR1Y5+pRyHqSF1enT7S0g1UTQXFnbs8GlWHDk2M4ILSSb1XfgkFuWGbavujAS2F5qGsHUbndfXVmkKIr4PtF6/KJPTPmyx7iNvQ1J0/WfDkMl48ytIYUNlpyva8dRbgY3qpwu92Ls24jmwxkbgZdnqmhw6gtlazXJj4jIrhcPvlGJZ9xAGVTESDGc5blmg1rXWF5eJZWtwbiGzDxRyFieO+S0sxJ6l3yR8No9KkpqT3VnHbu5yqgH44rJ4rk0i1uILbSLKOG4tpDxJYVdIyg91MMzFyPV/LnsetUczGN1ni5A/d+/yoLfQLn2TXLZiziJX3PsGSQOeMfHpR481OLVtaS4gSRE4CjEow2eeeXpVfZ3xhDSCIMwHq+KgXEzXE7yye85yaDHRRRQFPhlkgmSaFyksbBkdTgqR6im0lA+Dyyx4HJWH3VnlZVDJENxb33P4Co6nANLlnIUAkk4CgdTQNJOBz5U9XYDBJ245g03acZwcd8Uq5UhipxntQZZhEsaiPmxHNgaj1mBjYkONvYimSIY2KsKBlFLRQFFFFAU6OR42DxOyMOjKcEfbRRQKJZQoXiPtAIC7jjB6j6jS7nkBDyOQTk5YnJ7/XS0UEqG2hWAvcbuZ8pA5YqPMNwBzgAYGe1JRQYaKKKD/9k=", name: "When We Were Young", author: "Adele", duration: "4:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "2", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksgUBCNDVALchQAdWcQ3MmpfK9B54UKzXWw&usqp=CAU", name: "Cry Your Heart Out", author: "Adele", duration: "3:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "4", img: "https://images-na.ssl-images-amazon.com/images/I/71X-290hdOL.jpg", name: "Make You Feel Love", author: "Adele", duration: "1:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "5", img: "https://images.macrumors.com/t/U1y2-rMrcY1n8mKlIGE8XYbWAKM=/1600x1200/smart/article-new/2015/11/adele.jpg", name: "Someone Like You", author: "Adele", duration: "11:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-buddy.mp3', id: "6", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIADYASAMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAYDBQcCAf/EADUQAAEEAQEEBwUIAwAAAAAAAAEAAgMEEQUSITFRBhMUFUFUkiIjM2FxBzJTgYKRocFCUmL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOL93XfLSelfe7bvlpPSregQVMaNqR4UZz+godH1IcaU4/QrrJcbXiL3k48APEqRC2W0K0Qi66za+FCCQ0Dm443j+EHPzp1wHBrvB5L13RqHlJf2XSdU6IX4KgZHNTY4tw5scOM896rdJ8um3OxTyNkiLtkEH7rvogrfdGo+Tl9K8d23fLSeldBwtceJQU7u675aT0r6reiAiIOKCd0godlpUBHA54tsZILTne7a7cS36+G/l+1m6ANaLF63ZiaLIeIcneQAN+Pr/SjdFL0L2yaPqEbZatk+y1/AOWo1YydF+lHZn2nGlYYGvdnLmtO7JzxI5+IQWnpFrrbNa3FobmWbcY9rY9rYHicfJc91bSpuxW9QmNoFkjQx87NkyeBOFf8AR6Pdkj5orsVrMbWV4WRhjeeXHxJ8Sqvqti7NTt0r5if1shEXU/Didv8AYDjjaIx4ZwiIOi2+1VR1jsyM3OPPkV4PE/VaTSb4ozudI0ljhg44hbrOd/NFEREBBxWPtEP40frCCeHI99H6wg33R6MO13T2PGczjdzxv/pYPtbDm6zC7/FzOPzCm9GJqh6UU3SWa7YoI5ZS90rQA7AaBx/6Kj/afap2LleaGevYEbgS1sgcHDkcIK/ous6lpzSwV5Zomu2NktOWHl/I3fMKTqGvPnaWUtLdDbLMOleC9zGcMMB3NGeS0bNVDZorDoWGaNxJcJNzsgNOQc+DQOP5L4L9cR7HZx8PqydtnDa2uGxjj8kENzHBm0WkNPA43Kzt+6Poqy6ZnVbDcAcTl2clWJs8OyPfR8P9wgyosfaIfxo/WEQUlERAREQEREBERAREQf/Z", name: "Rolling in the Deep", author: "Adele", duration: "3:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "7", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAEgASAMBIgACEQEDEQH/xAAbAAABBAMAAAAAAAAAAAAAAAAAAQIEBQMGB//EADcQAAIBAwIEAwQIBgMAAAAAAAECAwAEEQUSEyExUQYiQRQyYZFCcYGhscHR8DRSZKLh8QcVM//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A5NRmkpKlR2TWyeHdkDqSM58xJPX/AB+pPatbQZYVe24ePhWowskpDSH+Udv32oN6lu8aZw7YhGk53Fyc4jX+VR6sfn+Wn6vql0q+z2ErR26eXyooyf1rLe6g2o3kOmwSbYUOCR/cx7n/AFW5eBdFtbxpNRkhHslsxjt4zzJYdXY+p9PnQcuutLv4FWS6gkTeNwL9cVBIKnFdN/5NuFYjaMc+VcyY5JoHq6CF0MKs5ORJuOV+zpRWOigWiirPT7GCK1XU9WV/Y9xWCBW2veOOoB+ig+k/2Dn0B+gabcXTm6EaraxNh7iZxHGG67dzEAn4Dn8Ktdc0WfSbgrqdzwbiRdzJGM7R23fZjl2qLY3slxM+t6qENhpwCwWqDZEz+8kEa+i8tzHrtBJJJBOw+PtSjt9Tiv7hUnv2gVrVJBuSFT5uM4PJmyTtU5AxuPoCGpaGOHqhQHIKsoP5/IV1JNQl8J+C7ZV9mV+FljMWOZHJYgAD49652tl/0xa9vXbjRFY5E/qH8zJ0+hGct2ZgvxroHiWaxurKP2qNZYNvQgHBxyPOg5prfiG51j+JjRSD1TNU5yOtT5bWe/1SSOzg4ryP5Vhj2j5dB+FZvEekzaPc21tc/wDq1sruOxJPL7qCpooooFq7sdGtdSj4y65DBbW8am5N1DLut1J5hQqlW8xbaoYFuw54qLeNZZ0jkmWFCfNK4JCD1OBzP1ep5VPklk1Oaz0fS0MVs06pbxyEZklcheJIR1Y5+pRyHqSF1enT7S0g1UTQXFnbs8GlWHDk2M4ILSSb1XfgkFuWGbavujAS2F5qGsHUbndfXVmkKIr4PtF6/KJPTPmyx7iNvQ1J0/WfDkMl48ytIYUNlpyva8dRbgY3qpwu92Ls24jmwxkbgZdnqmhw6gtlazXJj4jIrhcPvlGJZ9xAGVTESDGc5blmg1rXWF5eJZWtwbiGzDxRyFieO+S0sxJ6l3yR8No9KkpqT3VnHbu5yqgH44rJ4rk0i1uILbSLKOG4tpDxJYVdIyg91MMzFyPV/LnsetUczGN1ni5A/d+/yoLfQLn2TXLZiziJX3PsGSQOeMfHpR481OLVtaS4gSRE4CjEow2eeeXpVfZ3xhDSCIMwHq+KgXEzXE7yye85yaDHRRRQFPhlkgmSaFyksbBkdTgqR6im0lA+Dyyx4HJWH3VnlZVDJENxb33P4Co6nANLlnIUAkk4CgdTQNJOBz5U9XYDBJ245g03acZwcd8Uq5UhipxntQZZhEsaiPmxHNgaj1mBjYkONvYimSIY2KsKBlFLRQFFFFAU6OR42DxOyMOjKcEfbRRQKJZQoXiPtAIC7jjB6j6jS7nkBDyOQTk5YnJ7/XS0UEqG2hWAvcbuZ8pA5YqPMNwBzgAYGe1JRQYaKKKD/9k=", name: "When We Were Young", author: "Adele", duration: "4:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "8", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksgUBCNDVALchQAdWcQ3MmpfK9B54UKzXWw&usqp=CAU", name: "Cry Your Heart Out", author: "Adele", duration: "3:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "9", img: "https://images-na.ssl-images-amazon.com/images/I/71X-290hdOL.jpg", name: "Make You Feel Love", author: "Adele", duration: "1:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "10", img: "https://images.macrumors.com/t/U1y2-rMrcY1n8mKlIGE8XYbWAKM=/1600x1200/smart/article-new/2015/11/adele.jpg", name: "Someone Like You", author: "Adele", duration: "11:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-buddy.mp3', id: "11", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIADYASAMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAYDBQcCAf/EADUQAAEEAQEEBwUIAwAAAAAAAAEAAgMEEQUSITFRBhMUFUFUkiIjM2FxBzJTgYKRocFCUmL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOL93XfLSelfe7bvlpPSregQVMaNqR4UZz+godH1IcaU4/QrrJcbXiL3k48APEqRC2W0K0Qi66za+FCCQ0Dm443j+EHPzp1wHBrvB5L13RqHlJf2XSdU6IX4KgZHNTY4tw5scOM896rdJ8um3OxTyNkiLtkEH7rvogrfdGo+Tl9K8d23fLSeldBwtceJQU7u675aT0r6reiAiIOKCd0godlpUBHA54tsZILTne7a7cS36+G/l+1m6ANaLF63ZiaLIeIcneQAN+Pr/SjdFL0L2yaPqEbZatk+y1/AOWo1YydF+lHZn2nGlYYGvdnLmtO7JzxI5+IQWnpFrrbNa3FobmWbcY9rY9rYHicfJc91bSpuxW9QmNoFkjQx87NkyeBOFf8AR6Pdkj5orsVrMbWV4WRhjeeXHxJ8Sqvqti7NTt0r5if1shEXU/Didv8AYDjjaIx4ZwiIOi2+1VR1jsyM3OPPkV4PE/VaTSb4ozudI0ljhg44hbrOd/NFEREBBxWPtEP40frCCeHI99H6wg33R6MO13T2PGczjdzxv/pYPtbDm6zC7/FzOPzCm9GJqh6UU3SWa7YoI5ZS90rQA7AaBx/6Kj/afap2LleaGevYEbgS1sgcHDkcIK/ous6lpzSwV5Zomu2NktOWHl/I3fMKTqGvPnaWUtLdDbLMOleC9zGcMMB3NGeS0bNVDZorDoWGaNxJcJNzsgNOQc+DQOP5L4L9cR7HZx8PqydtnDa2uGxjj8kENzHBm0WkNPA43Kzt+6Poqy6ZnVbDcAcTl2clWJs8OyPfR8P9wgyosfaIfxo/WEQUlERAREQEREBERAREQf/Z", name: "Rolling in the Deep", author: "Adele", duration: "3:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "12", img: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAEgASAMBIgACEQEDEQH/xAAbAAABBAMAAAAAAAAAAAAAAAAAAQIEBQMGB//EADcQAAIBAwIEAwQIBgMAAAAAAAECAwAEEQUSEyExUQYiQRQyYZFCcYGhscHR8DRSZKLh8QcVM//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A5NRmkpKlR2TWyeHdkDqSM58xJPX/AB+pPatbQZYVe24ePhWowskpDSH+Udv32oN6lu8aZw7YhGk53Fyc4jX+VR6sfn+Wn6vql0q+z2ErR26eXyooyf1rLe6g2o3kOmwSbYUOCR/cx7n/AFW5eBdFtbxpNRkhHslsxjt4zzJYdXY+p9PnQcuutLv4FWS6gkTeNwL9cVBIKnFdN/5NuFYjaMc+VcyY5JoHq6CF0MKs5ORJuOV+zpRWOigWiirPT7GCK1XU9WV/Y9xWCBW2veOOoB+ig+k/2Dn0B+gabcXTm6EaraxNh7iZxHGG67dzEAn4Dn8Ktdc0WfSbgrqdzwbiRdzJGM7R23fZjl2qLY3slxM+t6qENhpwCwWqDZEz+8kEa+i8tzHrtBJJJBOw+PtSjt9Tiv7hUnv2gVrVJBuSFT5uM4PJmyTtU5AxuPoCGpaGOHqhQHIKsoP5/IV1JNQl8J+C7ZV9mV+FljMWOZHJYgAD49652tl/0xa9vXbjRFY5E/qH8zJ0+hGct2ZgvxroHiWaxurKP2qNZYNvQgHBxyPOg5prfiG51j+JjRSD1TNU5yOtT5bWe/1SSOzg4ryP5Vhj2j5dB+FZvEekzaPc21tc/wDq1sruOxJPL7qCpooooFq7sdGtdSj4y65DBbW8am5N1DLut1J5hQqlW8xbaoYFuw54qLeNZZ0jkmWFCfNK4JCD1OBzP1ep5VPklk1Oaz0fS0MVs06pbxyEZklcheJIR1Y5+pRyHqSF1enT7S0g1UTQXFnbs8GlWHDk2M4ILSSb1XfgkFuWGbavujAS2F5qGsHUbndfXVmkKIr4PtF6/KJPTPmyx7iNvQ1J0/WfDkMl48ytIYUNlpyva8dRbgY3qpwu92Ls24jmwxkbgZdnqmhw6gtlazXJj4jIrhcPvlGJZ9xAGVTESDGc5blmg1rXWF5eJZWtwbiGzDxRyFieO+S0sxJ6l3yR8No9KkpqT3VnHbu5yqgH44rJ4rk0i1uILbSLKOG4tpDxJYVdIyg91MMzFyPV/LnsetUczGN1ni5A/d+/yoLfQLn2TXLZiziJX3PsGSQOeMfHpR481OLVtaS4gSRE4CjEow2eeeXpVfZ3xhDSCIMwHq+KgXEzXE7yye85yaDHRRRQFPhlkgmSaFyksbBkdTgqR6im0lA+Dyyx4HJWH3VnlZVDJENxb33P4Co6nANLlnIUAkk4CgdTQNJOBz5U9XYDBJ245g03acZwcd8Uq5UhipxntQZZhEsaiPmxHNgaj1mBjYkONvYimSIY2KsKBlFLRQFFFFAU6OR42DxOyMOjKcEfbRRQKJZQoXiPtAIC7jjB6j6jS7nkBDyOQTk5YnJ7/XS0UEqG2hWAvcbuZ8pA5YqPMNwBzgAYGe1JRQYaKKKD/9k=", name: "When We Were Young", author: "Adele", duration: "4:21" },
            { audio: 'https://www.bensound.com/bensound-music/bensound-slowmotion.mp3', id: "13", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksgUBCNDVALchQAdWcQ3MmpfK9B54UKzXWw&usqp=CAU", name: "Cry Your Heart Out", author: "Adele", duration: "3:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "14", img: "https://images-na.ssl-images-amazon.com/images/I/71X-290hdOL.jpg", name: "Make You Feel Love", author: "Adele", duration: "1:21" },
            { audio: 'https://cdn.simplecast.com/audio/17ba21/17ba21db-66b5-4612-855e-556b20f60155/6cd39874-c070-417b-8cd0-481cb8c6e866/Undefined_E9_Nader_tc.mp3', id: "15", img: "https://images.macrumors.com/t/U1y2-rMrcY1n8mKlIGE8XYbWAKM=/1600x1200/smart/article-new/2015/11/adele.jpg", name: "Someone Like You", author: "Adele", duration: "11:21" },
        ],
        pause: false,
        currentDroppable: null,
        showMenu: false,
        showSearchbox: false,
        value: 0,
        isPlaying: false,
        repeat: false,
        showVolume: false,
        isRepeat: false,
        isActive: false,
        isShuffle: false,
        search_results: false,
        more: false,
        show: false,
        showList: false
    };

    handleClick = () => {
        this.setState({ showMenu: !this.state.showMenu })

    }
    handleVolume = () => {
        this.setState({ showVolume: !this.state.showVolume })

    }

    handleSearch = () => {
        this.setState({ showSearchbox: !this.state.showSearchbox, search_results: false })
        console.log(this.state.showSearchbox)

    }

    getInitialState = () => {
        return { value: 0, value2: 0 };
    }
    handleChange = (event) => {
        this.setState({ value: event.target.value2 });
    }
    handleChangevolume = (e) => {
        this.setState({ value: e.target.value });
    }

    goForwardBackward = (time) => {

        if (time == 'back') {
            // changes
            this.state.playerRef.currentTime = this.state.playerRef.currentTime - 10;
        } else if (time == 'fwd') {
            // changes
            this.state.playerRef.currentTime = this.state.playerRef.currentTime + 10;
        }
    }

    repeat = (time) => {

        if (time == 'repeat') {
            // changes
            this.state.isRepeat = !this.state.isRepeat
            this.playerRef.currentTime = -this.playerRef.currentTime;
            // let bound = this.timelineRef.getBoundingClientRect()
            // let percentage = ((e.clientX - bound.left)/bound.width)*100
            this.playheadRef.style.width = 100 + "%";

        }
    }

    componentDidMount() {
        this.playerRef.addEventListener("timeupdate", this.timeUpdate, false);
        this.playerRef.addEventListener("ended", () => {
            if (this.state.isRepeat) {
                console.log('hear');
                this.playerRef.currentTime -= this.playerRef.currentTime;
                this.playerRef.play();
            }
            else
                this.nextSong()
        }, false);
        this.timelineRef.addEventListener("click", this.changeCurrentTime, false);
        this.timelineRef.addEventListener("mousemove", this.hoverTimeLine, false);
        this.timelineRef.addEventListener("mouseout", this.resetTimeLine, false);
    }

    componentWillUnmount() {
        this.playerRef.removeEventListener("timeupdate", this.timeUpdate);
        this.playerRef.removeEventListener("ended", () => {
            if (this.state.isRepeat) {
                console.log('hear');
                this.playerRef.currentTime -= this.playerRef.currentTime;
                this.updatePlayer();

            }
            else
                this.nextSong()
        }
        );
        this.timelineRef.removeEventListener("click", this.changeCurrentTime);
        this.timelineRef.removeEventListener("mousemove", this.hoverTimeLine);
        this.timelineRef.removeEventListener("mouseout", this.resetTimeLine);
    }

    changeCurrentTime = (e) => {
        const duration = this.playerRef.duration;
        const playheadWidth = this.timelineRef.offsetWidth;
        const offsetWidht = this.timelineRef.offsetLeft;
        const userClickWidht = e.clientX / 2 - offsetWidht;

        const userClickWidhtInPercent = (userClickWidht * 100) / playheadWidth;

        let bound = this.timelineRef.getBoundingClientRect()

        let percentage = ((e.clientX - bound.left) / bound.width) * 100
        this.playheadRef.style.width = percentage + "%";
        this.playerRef.currentTime = (duration) * percentage / 100;
        console.log(bound)
    }

    hoverTimeLine = (e) => {
        const duration = this.playerRef.duration;

        const playheadWidth = this.timelineRef.offsetWidth

        const offsetWidht = this.timelineRef.offsetLeft;
        const userClickWidht = e.clientX - offsetWidht;
        const userClickWidhtInPercent = (userClickWidht * 100) / playheadWidth;

        if (userClickWidhtInPercent <= 100) {
            this.hoverPlayheadRef.style.width = userClickWidhtInPercent + "%";
        }

        const time = (duration * userClickWidhtInPercent) / 100;

        if ((time >= 0) && (time <= duration)) {
            this.hoverPlayheadRef.dataset.content = this.formatTime(time);
        }
    }
    resetTimeLine = () => {
        this.hoverPlayheadRef.style.width = 0;
    }

    timeUpdate = () => {
        const duration = this.playerRef.duration;
        const timelineWidth = this.timelineRef.offsetWidth - this.playheadRef.offsetWidth;
        const playPercent = 100 * (this.playerRef.currentTime / duration);
        this.playheadRef.style.width = playPercent + "%";
        const currentTime = this.formatTime(parseInt(this.playerRef.currentTime));
        this.setState({
            currentTime
        });
    }

    formatTime = (currentTime) => {
        const minutes = Math.floor(currentTime / 60);
        let seconds = Math.floor(currentTime % 60);

        seconds = (seconds >= 10) ? seconds : "0" + seconds % 60;

        const formatTime = minutes + ":" + seconds

        return formatTime;
    }


    updatePlayer = () => {
        const { musicList, index } = this.state;
        const currentSong = musicList[index];
        const audio = new Audio(currentSong.audio);
        this.playerRef.load();
    }
    nextSong = () => {
        const { musicList, index, pause } = this.state;
        const next_index = this.state.isShuffle ? Math.floor(Math.random() * musicList.length) : (index + 1) % musicList.length

        this.setState({
            index: next_index
        });
        this.updatePlayer();
        if (pause) {
            this.playerRef.play();
        }

    };

    prevSong = () => {
        const { musicList, index, pause } = this.state;
        const next_index = this.state.isShuffle ? Math.floor(Math.random() * musicList.length) : (index + musicList.length - 1) % musicList.length;
        this.setState({
            index: next_index
        });
        this.updatePlayer();
        if (pause) {
            this.playerRef.play();
        }
    };
    shuffle = () => {
        this.setState(
            {
                isShuffle: !this.state.isShuffle,
                isActive: !this.state.isActive
            }
        )
    }

    playOrPause = () => {
        const { musicList, index, pause } = this.state;
        const currentSong = musicList[index];
        const audio = new Audio(currentSong.audio);
        if (!this.state.pause) {
            this.playerRef.play();
        } else {
            this.playerRef.pause();
        }
        this.setState({
            pause: !pause
        })
    }

    clickAudio = (key) => {
        const { pause } = this.state;

        this.setState({
            index: key
        });

        this.updatePlayer();
        if (pause) {
            this.playerRef.play();
        }
    }

    filter = (e) => {
        // const [name, setName] = useState('');
        // const [foundUsers, setFoundUsers] = useState(this.state.musicList);
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = this.state.musicList.filter((user) => {
                return user.name.toLowerCase().startsWith(keyword.toLowerCase());
            });
            this.setState(
                {
                    search_results: results
                }
            )
        }
    };

    constructor(props) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this)
    }

    onDragEnd(result) {
        if (!result.destination)
            return;

        const items = reorder(
            this.state.musicList,
            result.source.index,
            result.destination.index
        )
        this.setState(
            {
                musicList: items
            }
        )
    }

    dragStart = (e) => {
        let el = e.target.getBoundingClientRect()
        this.setState({
            initialData: {
                elWidth: el.width,
                elLeft: el.left
            }
        }, () => {
            window.addEventListener('mousemove', this.mouseMove);
            window.addEventListener('mouseup', this.mouseUp);

        })
        // e.dataTransfer.setData("Text", e.target.id);
    }
    mouseMove = (e) => {
        const duration = this.playerRef.duration;
        const playheadWidth = this.timelineRef.offsetWidth;
        const offsetWidht = this.timelineRef.offsetLeft;
        const userClickWidht = e.clientX / 2 - offsetWidht;

        const userClickWidhtInPercent = (userClickWidht * 100) / playheadWidth;

        let bound = this.timelineRef.getBoundingClientRect()

        let percentage = ((e.clientX - bound.left) / bound.width) * 100
        this.playheadRef.style.width = percentage + "%";
        this.playerRef.currentTime = (duration) * percentage / 100;

    }
    mouseUp = () => {
        window.removeEventListener("mousemove", this.mouseMove)
        window.removeEventListener("mouseup", this.mouseUp)

    }
    dragEnd = (e) => {

    }

    allowDrop = (event) => {
        event.preventDefault();
    }

    drop = (event) => {
        event.preventDefault();
        var data = event.dataTransfer.getData("Text");
        event.target.appendChild(document.getElementById(data));
    }

    render() {
        const { musicList, index, currentTime, pause } = this.state;
        const currentSong = musicList[index];
        return (
            <div className=" w-100 flexcc" style={{ backgroundColor: '#fff', borderBottom:'1px solid #eee' }}>
                <div className='h-100 p-3'>
                    <div className="h-100 w-100">
                        <div className="currentlist flexcb" style={{}}>
                            <div className="flexc" style={{}}>
                                {this.state.show
                                    ? <img className="currentimageTower" src={currentSong.img} />
                                    : <button className="flexcc play current-btn" style={{width:'40px'}} onClick={this.playOrPause}>
                                        {(!pause)
                                            ? < img width={22} src="/assets/icons/tower/play.svg" />
                                            : <img width={22} src="/assets/icons/tower/pause.svg" />
                                        }
                                    </button>
                                }
                                <div className="">
                                    <div style={{ display: "flex", flexDirection: "row", padding: "0rem .5rem" }}>
                                        <div className="namedesc">
                                            <p className="weight-600 font-size-12 main-c2" style={{ lineHeight: "15px" }}>{currentSong.name}</p>
                                            <p className="font-size-10 main-c7">{currentSong.author}</p>
                                        </div>
                                    </div>
                                    <audio id="myAudio" ref={ref => this.playerRef = ref} >
                                        <source src={currentSong.audio} type="audio/ogg" />
                                    </audio>
                                </div>
                            </div>
                            <button className="flexcc" onClick={() => { this.setState({ more: !this.state.more, show: !this.state.show }) }}>
                                <img width={20} src="/assets/icons/tower/arrow-right.svg" className={this.state.show ? " optionImageTower " : (this.props.language == 'fa' ? ' optionImageTower2 rotate-90' : 'optionImageTower2 rotate-270')} />
                            </button>
                        </div>
                        <Collapsible open={this.state.show}>
                            <div className="musicbarTower cursor-pointer">
                                <div ref={ref => this.timelineRef = ref} id="timeline" className="droptarget cursor-poniter rtl-button" >
                                    <div ref={ref => this.playheadRef = ref} className="droptarget cursor-pointer" id="playhead" style={{ position: 'relative', paddingLeft: '12px', height: '5px', background: '#444' }}>
                                        <div onMouseDownCapture={(e) => this.dragStart(e)} id="ball" className="thumb " style={{ right: 0, background: '#444' }} ref={ref => this.PlayheadRef = ref}></div>
                                    </div>
                                    <div id="demo"></div>
                                    <div ref={ref => this.hoverPlayheadRef = ref} className="hover-playhead" data-content="0:00"></div>
                                </div>
                                {this.props.language == 'fa' ?
                                    <div className="currentdurationTower">
                                        <p>{currentSong.duration}</p>
                                        <p>{currentTime}</p>
                                    </div>
                                    :
                                    <div className="currentdurationTower">
                                        <p>{currentTime}</p>
                                        <p>{currentSong.duration}</p>
                                    </div>
                                }
                            </div>
                            <div className="svglist pt-3" style={{ justifyContent: 'space-between' }}>
                                <div className="svg-groups">
                                    <button className="flexcc mrd-2" onClick={() => { this.setState({ showList: !this.state.showList }) }}>
                                        <img width={20} src="/assets/icons/tower/list.svg" />
                                    </button>
                                    <button className="flexcc" onClick={this.shuffle}>
                                        <img width={20} src="/assets/icons/tower/shuffle.svg" />
                                    </button>
                                </div >
                                <div className="svg-groups flexc" style={{}}>
                                    <button className="flexcc px-2" onClick={this.prevSong}>
                                        <img width={24} src="/assets/icons/tower/backward.svg" />
                                    </button>
                                    <button className="flexcc px-2 play current-btn" onClick={this.playOrPause}>
                                        {(!pause)
                                            ? < img width={24} src="/assets/icons/tower/play.svg" />
                                            : <img width={24} src="/assets/icons/tower/pause.svg" />
                                        }
                                    </button>
                                    <button className="flexcc px-2" onClick={this.nextSong}>
                                        <img width={24} src="/assets/icons/tower/forward.svg" />
                                    </button>
                                </div >
                                <div className="svg-groups">
                                    <button className="flexcc" onClick={() => this.repeat("repeat")}>
                                        <img width={20} src="/assets/icons/tower/repeat.svg" />
                                    </button>
                                    <button className="flexcc mld-2">
                                        <img width={20} src="/assets/icons/tower/close.svg" />
                                    </button>
                                </div >
                            </div>
                            <Collapsible open={this.state.showList}>
                                <div className="listTower scroll-no-scrollbar pt-2 mt-2 br-10" style={{ maxHeight: '250px', backgroundColor: '#fff' }}>
                                    <div className="w-100 row">
                                        {this.state.musicList.map((song, index) => {
                                            return (
                                                <div className="songlistTower py-2 mx-3 cursor-pointer bb-gray" key={song.id} onClick={() => { this.setState({ currentsong: { ...song, current: 0 } }) }}>
                                                    <div className="flexc" style={{}}>
                                                        <img className="currentimageTower" src={song.img} />

                                                        <div style={{ display: "flex", flexDirection: "row", padding: "0rem .5rem" }}>
                                                            <div className="namedesc">
                                                                <p className="weight-500 font-size-11" href={song.hreff} style={{ lineHeight: "15px" }}>{song.name}</p>
                                                                <p className="font-size-10" href={song.hreff} style={{ color: "#777" }}>{song.author}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </Collapsible>
                        </Collapsible>
                    </div>
                </div>
            </div>
        )
    }
}